import { Controller } from 'stimulus';
import { getAjaxModal } from 'lib/ajax-helpers';
import Cookies from 'js-cookie';

export default class ApplicationController extends Controller {
  connect() {
    this.showEmailVerifiedModal();
  }

  showEmailVerifiedModal() {
    const showVerifiedModal = Cookies.get('show_email_verified_modal');

    if (showVerifiedModal === 'true') {
      Cookies.remove('show_email_verified_modal');
      // Dont reload page after survey dismissal
      Cookies.set('no_verified_survey_dismissal_reload', true);

      getAjaxModal('/render_email_verified_modal');
    }
  }
}
